<script setup lang="ts">
import { LayoutDashboard } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
<template>
  <main
    class="relative isolate flex min-h-screen max-w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-950 text-slate-100"
  >
    <div
      aria-hidden="true"
      class="pointer-events-none absolute -top-64 left-1/2 h-[30rem] w-[64rem] -translate-x-1/2 rounded-full bg-blue-500/12 blur-[140px]"
    />
    <div
      aria-hidden="true"
      class="pointer-events-none absolute -bottom-72 left-1/3 h-[28rem] w-[56rem] -translate-x-1/2 rounded-full bg-cyan-600/10 blur-[140px]"
    />
    <div class="relative z-10 mb-5 flex w-full items-center justify-center gap-2">
      <LayoutDashboard class="h-6 w-6 text-cyan-300" />
      <span class="text-xl font-semibold tracking-tight">
        {{ t('app.title') }}
      </span>
    </div>
    <div class="relative z-10">
      <RouterView />
    </div>
  </main>
</template>
